import { urlObjectToString } from './url-object-to-string';
import type { Href } from './types';

const EXTERNAL_URL_PATTERN = /^\s*(https?:|mailto:|tel:|sms:|ftp:|\/\/)/i;

export function isExternalUrl(href: Href): boolean {
  const hrefStr = urlObjectToString(href);
  return EXTERNAL_URL_PATTERN.test(hrefStr);
}
